// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3JUki","fileBtn":"File_fileBtn__-_0zd","closeBtn":"File_closeBtn__2mI3S","fileSelected":"File_fileSelected__2GZNE","disabled":"File_disabled__2Jt7b"};